<ng-container ngForm (ngSubmit)="add()" appPromptUnsubmitted>
    <td>
        <input type="text" class="form-control" name="code" [(ngModel)]="rowCertificate.code"
            placeholder="{{placeholder}}" [appIsInvalid]="false" [submitted]="wasSubmitted">
    </td>
    <td>
        <div *ngIf="state === states.Add" class="input-group">
            <ng-select class="form-control multiselect" name="customers" #selectNewCus [(ngModel)]="selectedAddCust"
                [appIsInvalid]="!selectedAddCust" [submitted]="wasSubmitted">
                <ng-option *ngFor="let cust of customers" [value]="cust.id">{{cust.name}}</ng-option>
            </ng-select>
            <span class="input-group-append">
                <button class="btn btn-link" type="button">
                    <i class="icon-user-follow" (click)="showCustomer()"></i>
                </button>
            </span>
            <div *ngIf="!selectedAddCust" class="invalid-feedback">
                Customer is Required
            </div>
        </div>
        <div *ngIf="state === states.Edit" class="input-group">
            <ng-select class="form-control multiselect" name="customers" [(ngModel)]="selectedEditCust"
                [appIsInvalid]="!selectedEditCust" [submitted]="wasSubmitted">
                <ng-option *ngFor="let cust of customers" [value]="cust.id">{{cust.name}}</ng-option>
            </ng-select>
            <div *ngIf="!selectedEditCust" class="invalid-feedback">
                Customer is Required
            </div>
        </div>
        <div *ngIf="state === states.Idle" class="input-group">
            <input type="text" class="form-control" name="customerShow" [ngModel]="rowCertificate.customerName">
        </div>
    </td>
    <td>
        <div *ngIf="state === states.Add" class="input-group">
            <ng-select class="form-control multiselect" name="siteAreas" #selectNewCus [(ngModel)]="selectedPlantingSiteArea" [selectOnTab]="checkLimitTrees(selectedPlantingSiteArea)"
                [appIsInvalid]="!selectedPlantingSiteArea" [submitted]="wasSubmitted">
                <ng-option *ngFor="let siteArea of plantingSiteAreas" [value]="siteArea.id" >{{siteArea.name}}</ng-option>
            </ng-select>
            <div *ngIf="!selectedPlantingSiteArea" class="invalid-feedback">
                Planting area is Required
            </div>
        </div>
        <div *ngIf="state === states.Edit" class="input-group">
            <ng-select class="form-control multiselect" name="siteAreas" [(ngModel)]="selectedEditAreaId" [selectOnTab]="checkLimitTrees(selectedEditAreaId)"
                [appIsInvalid]="!selectedEditAreaId" [submitted]="wasSubmitted">
                <ng-option *ngFor="let siteArea of plantingSiteAreas" [value]="siteArea.id" >{{siteArea.name}}</ng-option>
            </ng-select>
            <div *ngIf="!selectedEditAreaId" class="invalid-feedback">
                Planting site is Required
            </div>
        </div>
        <div *ngIf="state === states.Idle" class="input-group">
            <input type="text" class="form-control" name="siteArea" [ngModel]="rowCertificate.plantingSiteAreaName">
        </div>
    </td>
    <td class="text-right">
        <input class="form-control text-right" type="number" name="count" [submitted]="wasSubmitted"
            [appIsInvalid]="!rowCertificate.count || rowCertificate.count <= 0 || (rowCertificate.count | hasDecimal) || rowCertificate.count > max"
            [(ngModel)]="rowCertificate.count"  >
        <div *ngIf="!rowCertificate.count && rowCertificate.count !== 0" class="invalid-feedback">
            Number of trees purchased is Required
        </div>
        <div *ngIf="rowCertificate.count <= 0" class="invalid-feedback">
            Number of trees purchased should be greater than zero
        </div>
        <div *ngIf="rowCertificate.count | hasDecimal" class="invalid-feedback">
            Number of trees purchased must be an integer value
        </div>
        <div *ngIf="rowCertificate.count > max" class="invalid-feedback">
            The selected planting has {{max}} available trees.
        </div>
    </td>

    <td>
        <div class="custom-control custom-checkbox checkbox set-middle" (click)="toggleShow()">
            <input type="checkbox" class="custom-control-input" name="isShow" id="{{rowCertificate.id}}"
                [(ngModel)]="rowCertificate.isShow">
            <label class="custom-control-label" title="title" for="{{rowCertificate.id}}"></label>
        </div>
    </td>

    <ng-container *ngIf="!isEditRow; else editAction">
        <td class="table-button">
            <button type="submit" (click)="add()" class="btn btn-primary">Add</button>
        </td>
    </ng-container>

    <ng-template #editAction>
        <td class="table-button">
            <div class="button-set">
                <a class="text-primary" (click)="applyChanges()"><i class="icon-check"></i></a>
                <a class="text-danger" (click)="revertChanges()"><i class="icon-close"></i></a>
            </div>
            <a class="edit" (click)="openEdit()" title="Edit"><i class="icon-note"></i></a>
            <a class="delete" (click)="openDelete()" title="Delete"><i class="icon-trash"></i></a>
        </td>
    </ng-template>
</ng-container>
